import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import ServerErrorVector from 'assets/vectors/ServerError.svg';
import Button from 'components/Button';
import { useAppDispatch } from 'hooks/useStore';
import { clearError } from 'store/error';
import './index.css';

function ServerError() {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    return (
        <div className='layout serverError'>
            <Helmet>
                <title>
                    Server Error
                </title>
            </Helmet>
            <img
                className='serverError__image'
                src={ServerErrorVector}
                alt='Server Error'
            />
            <h1 className='serverError__title'>
                Server Error
            </h1>
            <p className='serverError__text'>
                Uh-oh, something went wrong.<br/>
                We are looking to see what happened. Please try again later.
            </p>
            <Button
                className='serverError__button'
                onClick={() => {
                    navigate('/');
                    dispatch(clearError());
                }}
            >
                BACK HOME
            </Button>
        </div>
    );
}

export default ServerError;